module.exports = __webpack_public_path__ + "img/2015014.eb8624fe.svg";